<template>
  <el-dialog
    :title="$t('myResources.main_CHANGE_PASSWORD_TOOLTIP')"
    :visible="innerVisible"
    custom-classs="modify-password-dialog"
    destroy-on-close
    class="modify-password-dialog"
    :close-on-click-modal="false"
    width="380px"
    append-to-body
    @close="handleClose"
  >
    <el-form inline :label-width="isZh?'100px':'180px'">
      <el-form-item :label="$t('myResources.password_oldPassword')">
        <el-input v-model="oldPwd" type="password" />
      </el-form-item>
      <el-form-item :label="$t('myResources.password_newPassword')">
        <el-input v-model="newPwd" type="password" />
      </el-form-item>
      <el-form-item :label="$t('myResources.password_confirmTheNewPassword')">
        <el-input v-model="confirmPwd" type="password" />
      </el-form-item>
    </el-form>
    <p style="font-weight: bold">{{ passwordMessage }}</p>
    <div slot="footer" style="text-align: center">
      <el-button @click="handleClose">{{ $t('myResources.CANCEL') }}</el-button>
      <el-button type="primary" @click="modifyPwd">{{ $t('myResources.OK') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Assert } from '@/utils/validate'
import { changePassword } from '@/api/user'
import { checkPasswordRuleFunc, queryUserSecurityPolicyFunc } from '@/api/userSecurityPolicy'

export default {
  name: 'ModifyPasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      innerVisible: false,
      oldPwd: '',
      newPwd: '',
      passwordMessage: '',
      confirmPwd: ''
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async init() {
      this.passwordMessage = this.$t('myResources.password_notCompliant')
      const res = await queryUserSecurityPolicyFunc()
      if (res.data) {
        const upVo = res.data
        // 平台客服不受控制
        if (upVo.policyEnabled && (this.$store.getters.userInfo.userType === 3 || this.$store.getters.userInfo.userType === 2 && upVo.applyToAdmin)) {
          this.passwordMessage = this.passwordTip(upVo)
        }
      }
    },
    async modifyPwd() {
      await Assert.isTrue(this.oldPwd, this.$t('myResources.PleaseEnterAOldPassword'))
      await Assert.isTrue(this.newPwd, this.$t('myResources.PleaseEnterANewPassword'))
      await Assert.isTrue(this.confirmPwd, this.$t('myResources.PleaseEnterTheConfirmationPassword'))
      await Assert.isTrue(this.oldPwd.length >= 8 <= 20 && this.newPwd.length >= 8 <= 20 && this.confirmPwd.length >= 8 <= 20, this.$t('myResources.password_notCompliant'))
      await Assert.isTrue(this.newPwd === this.confirmPwd, this.$t('myResources.TheNewPasswordDoesNotMatchTheConfirmedNewPassword'))
      await Assert.isTrue(this.newPwd !== this.oldPwd, this.$t('myResources.TheNewPasswordDoesNotMatchTheOldPassword'))
      const data = {
        type: this.$store.getters.userInfo.userType,
        userId: this.$store.getters.userId,
        password: this.newPwd
      }
      const res = await checkPasswordRuleFunc(data)
      if (res.data) {
        const upVo = res.data
        if (!upVo.result) {
          const tip = this.passwordTip(upVo)
          this.$message.warning(tip)
          return false
        }
      } else {
        await Assert.isTrue(this.checkPassword(this.newPwd), this.$t('myResources.password_notCompliant'))
      }
      // 调用接口更新密码
      changePassword(this.oldPwd, this.newPwd).then(res => {
        this.logout()
      })
    },
    passwordTip(upVo) {
      let d = this.$t('CargoMsg.Cargo_PasswordRulePrompt', [upVo.minPasswordLength, upVo.maxPasswordLength])
      if (upVo.requireSpecialChar) {
        d += ',' + this.$t('CargoMsg.Cargo_MustIncludeSpecialChars')
      }
      if (upVo.passwordRepeatCheck) {
        d += ',' + this.$t('CargoMsg.Cargo_NoRepeatLastNPasswords', [upVo.passwordRepeatCheck])
      }
      return d
    },
    logout() {
      this.$store.dispatch('tagsView/delAllViews').then(() => {
        return this.$store.dispatch('user/logout')
      }).then(() => {
        // location.reload()// In order to re-instantiate the vue-router object to avoid bugs
        this.$router.push('/login')
      }).catch(() => {
        location.reload()
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    checkPassword(val) {
      if (!val) return false
      // 检查长度是否在8-20之间
      if (val.length < 8 || val.length > 20) return false
      // 检查是否包含数字
      if (!/\d/.test(val)) return false
      // 检查是否包含小写字母
      if (!/[a-z]/.test(val)) return false
      // 检查是否包含大写字母
      if (!/[A-Z]/.test(val)) return false
      return true
    }
  }
}
</script>
<style lang="scss">
.modify-password-dialog{
  label {
    font-weight: normal;
  }
}
</style>
